// src/App.js
import React, { useContext } from "react";
import "./App.css";
import { MapProvider } from "./contexts/MapContext";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MapHandler from "./components/MapHandler"; // Import the MapHandler component
import { SnackbarContextProvider } from "./contexts/SnackbarContext";
import PrivateRoute from "./components/PrivateRoute";
import Login from "./components/Login"; // Import the Login component
import { AuthContext, AuthProvider } from "./contexts/AuthContext";
import Impressum from "./pages/Impressum";
import AboutPage from "./pages/AboutPage";
import MapList from "./components/MapList";

import { useLocation, Navigate } from "react-router-dom";

const RedirectWithSearch = ({ redirectTo }: { redirectTo: string }) => {
  const location = useLocation();
  return <Navigate to={`${redirectTo}${location.search}`} replace />;
};

// Logout component that handles the logout action
const Logout = () => {
  const { logoutUser } = useContext(AuthContext);
  
  React.useEffect(() => {
    logoutUser();
    // Redirect to login page after logout
    window.location.href = "/login";
  }, [logoutUser]);

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
      <p>Logging out...</p>
    </div>
  );
};

export default function App() {
  return (
    <BrowserRouter>
      <SnackbarContextProvider>
        <AuthProvider>
          <MapProvider>
            <div className="App">
              <Routes>
                {/* Use RedirectWithSearch to preserve query parameters (e.g. the key) */}
                <Route path="/" element={<RedirectWithSearch redirectTo="/map/v2_2" />} />
                <Route path="/login" element={<Login />} />
                <Route path="/logout" element={<Logout />} />
                <Route path="/impressum" element={<Impressum />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/list_maps" element={<MapList />} />
                {/* Protected Routes */}
                <Route element={<PrivateRoute />}>
                  <Route path="/map/:name" element={<MapHandler />} />
                  <Route path="/map/:name/search/:query" element={<MapHandler />} />
                  <Route path="/map/:name/search/:query/coordinates/:coordinates" element={<MapHandler />} />
                  <Route path="/map/:name/author/:authorId" element={<MapHandler />} />
                  <Route path="/map/:name/author/:authorId/coordinates/:coordinates" element={<MapHandler />} />
                  <Route path="/map/:name/journal/:journalId" element={<MapHandler />} />
                  <Route path="/map/:name/journal/:journalId/coordinates/:coordinates" element={<MapHandler />} />
                  <Route path="/map/:name/corpus/:corpusId" element={<MapHandler />} />
                  <Route path="/map/:name/corpus/:corpusId/coordinates/:coordinates" element={<MapHandler />} />
                  <Route path="/map/:name/cluster/:clusterId" element={<MapHandler />} />
                  <Route path="/map/:name/cluster/:clusterId/coordinates/:coordinates" element={<MapHandler />} />
                  <Route path="/map/:name/search/:query/author/:authorId" element={<MapHandler />} />
                  <Route path="/map/:name/search/:query/author/:authorId/coordinates/:coordinates" element={<MapHandler />} />
                  <Route path="/map/:name/search/:query/cluster/:cluster_id" element={<MapHandler />} />
                  <Route path="/map/:name/search/:query/cluster/:cluster_id/coordinates/:coordinates" element={<MapHandler />} />
                  <Route path="/map/:name/search/:query/corpus/:corpusId" element={<MapHandler />} />
                  <Route path="/map/:name/search/:query/corpus/:corpusId/coordinates/:coordinates" element={<MapHandler />} />
                  <Route path="/map/:name/author/:authorId/corpus/:corpusId" element={<MapHandler />} />
                  <Route path="/map/:name/author/:authorId/corpus/:corpusId/coordinates/:coordinates" element={<MapHandler />} />
                  <Route path="/map/:name/coordinates/:coordinates" element={<MapHandler />} />
                </Route>
                {/* 404 Route - Must be last */}
                <Route
                  path="*"
                  element={
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "100vh",
                        textAlign: "center",
                      }}
                    >
                      <img
                        src={"/logowide.png"}
                        alt="Logo"
                        style={{ width: "200px", height: "auto" }}
                      />
                      <h1 style={{ fontSize: "3rem", marginBottom: "1rem" }}>404</h1>
                      <h2 style={{ marginBottom: "2rem" }}>Page Not Found</h2>
                      <p>
                        The page you're looking for doesn't exist or has been moved.
                      </p>
                    </div>
                  }
                />
              </Routes>
            </div>
          </MapProvider>
        </AuthProvider>
      </SnackbarContextProvider>
    </BrowserRouter>
  );
}